import { render, staticRenderFns } from "./User-setting.vue?vue&type=template&id=1b79e880&scoped=true"
import script from "./User-setting.vue?vue&type=script&lang=js"
export * from "./User-setting.vue?vue&type=script&lang=js"
import style0 from "./User-setting.vue?vue&type=style&index=0&id=1b79e880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b79e880",
  null
  
)

export default component.exports